module.exports = __webpack_public_path__ + "img/base-whitewoman.b93dcbec.svg";